import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=bf317f00&scoped=true&"
import script from "./ProjectSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelect.vue?vue&type=style&index=0&id=bf317f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf317f00",
  null
  
)

export default component.exports